import { Label } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './SeriaPlusLabel.css';

export const SeriaPlusLabel: FC = () => (
  <div className={styles['container']}>
    <Label background="#fc4c02" color="text-inverted-default" data-testid="carousel-labels.seria-plus">
      Серия плюс
    </Label>
  </div>
);
